<template>
  <div class="marker-info">
    <div class="edu-title-info">
      <img style="display:block"
           src="@/assets/img/baiduMapIcon/edu-info-icon.png"
           alt="">
      <div class="title-and-address">
        <div class="title"
             v-if="eduInfo.basicInformationOfEducationBureaus">
          {{eduInfo.basicInformationOfEducationBureaus.eduBuresuName || '--'}}
        </div>
        <div class="title"
             v-else>
          ***
        </div>
        <div class="address"
             v-if="eduInfo.basicInformationOfEducationBureaus">
          {{eduInfo.basicInformationOfEducationBureaus.contactAddress || '--'}}
        </div>
        <div class="address"
             v-else>
          ***
        </div>
      </div>
    </div>
    <div class="edu-content" style="margin-top: 10px;">
      <div class="content-left">
        <div class="content-top"
             v-if="eduInfo.educationBureauPopUpInformation">
          学校数量：{{eduInfo.educationBureauPopUpInformation[0].numberOfSchools+'' || '--'}}
        </div>
        <!-- <div class="content-bottom"></div> -->
      </div>
      <div class="content-right">
        <div class="content-top"
             v-if="eduInfo.educationBureauPopUpInformation">
          巡查点数量：{{eduInfo.educationBureauPopUpInformation[0].numberOfInspectionPoints+'' || '--'}}
        </div>
        <!-- <div class="content-bottom"></div> -->
      </div>
    </div>
    <div class="edu-content" style="margin-top: 10px;">
      <div class="content-left">
        <div class="content-top"
             v-if="eduInfo.educationBureauPopUpInformation">
          学生数量：{{eduInfo.educationBureauPopUpInformation[0].numberOfStudents+'' || '--'}}
        </div>
        <!-- <div class="content-bottom"></div> -->
      </div>
      <div class="content-right">
        <div class="content-top"
             v-if="eduInfo.educationBureauPopUpInformation">
          上报隐患数量：{{eduInfo.educationBureauPopUpInformation[0].numberOfHiddenDangers+'' || '--'}}
        </div>
        <!-- <div class="content-bottom"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'eduBmInfoWindow',
  props: {
    info: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  data () {
    return {
      eduInfo: {}
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
    info: {
      handler (nval, oval) {
        this.eduInfo = nval || {}
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
.marker-info{
    width: 263px;
    height: 140px;
    background: url('~@/assets/img/baiduMapIcon/new-map-marker-edu-bg.png');
    background-size: 100% 100%;
    
}
/* edu-info-icon */
.edu-title-info{
    display: flex;
    flex-direction: row;
    margin-left: 20px;
    margin-top: 28px;
    height: 52px;
    img{
        margin-top: 10px;
        width: 42px;
        height: 42px;
    }
    .title-and-address{
        margin-left: 8px;
        display: flex;
        flex-direction: column;
        margin-top: 10px;
        width: 180px;
        .title{
            font-size: 14px;
            color: #FFFF00;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
        }
        .address{
          margin-top: 5px;
            font-size: 8px;
            color: #BEE8FF;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
        }
    }
}
.edu-content{
    display: flex;
    flex-direction: row;
    height: 25px;
    align-items: center;
    .content-left{
        display: flex;
        flex-direction: column;
        margin-left: 31px;
        width: calc(50% - 31px);
        .content-top{
            color: #D1E6FF;
            font-size: 12px;
            height: 17px;
        }
        .content-bottom{
            margin-top: 8px;
            height: 2px;
            width: 80%;
            background-image: linear-gradient(to left,rgba(129,134,213, 0), rgba(63,120,188,0.8),rgba(#4A4EAB,0));
        }
    }
    .content-right{
        display: flex;
        flex-direction: column;
        margin-left:11px;
        width: calc(50% - 1px);
        .content-top{
            color: #D1E6FF;
            font-size: 12px;
            height: 17px;
        }
        .content-bottom{
            margin-top: 8px;
            height: 2px;
            width: 80%;
            background-image: linear-gradient(to left,rgba(129,134,213, 0), rgba(63,120,188,0.8),rgba(#4A4EAB,0));
        }
    }
}


</style>